let store = require("../store");
let actions = require("../actions");

let Check = mc.widgets.Check;
let Pulse = mc.widgets.Pulse;
let FormControls = mc.widgets.FormControls;

class CompleteStudyView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmed: false,
      submitting: false,
      submitted: false
    };
  }

  setConfirmed(confirmed) {
    this.setState({ confirmed });
  }

  submit() {
    let { study, intent } = this.props;

    this.setState({
      submitting: true
    });

    let lifecycleState = intent === "start" ? "IN_PROGRESS" : "COMPLETE";
    let wait = mc.ui.wait(1000);
    let request = actions.saveStudy({ ...study, lifecycleState }, "UPDATE");

    Promise.all([wait, request]).then((results) => {
      let payload = results[1];

      if (payload.errors.length) {
        mc.ui.alert(tx("error.general"));
      }

      this.setState({
        submitting: false,
        submitted: !payload.errors.length
      });
    });
  }

  static open(study, intent) {
    let opts = {
      width: "475px",
      height: "425px",
      verticalAlign: "center"
    };

    mc.ui.modal(<CompleteStudyView study={study} intent={intent}/>, opts);
  }

  close() {
    mc.ui.modal(null);
  }

  render() {
    let { intent } = this.props;
    let { confirmed, submitting, submitted } = this.state;

    if (submitted) {
      return (
        <div className="rc-lifecycle-prompt-view">
          <img src="./img/rc/done.svg" width="100" height="92"/>
          <p>{tx("study_intent." + intent + ".result")}</p>
          <button className="mc-button" onClick={this.close}>
            {tx("okay")}
          </button>
        </div>
      );
    }

    if (submitting) {
      return (
        <div className="rc-lifecycle-prompt-view">
          <Pulse/>
        </div>
      );
    }

    return (
      <div className="rc-lifecycle-prompt-view">
        <img src="./img/rc/wait.svg" width="100" height="92"/>
        <p>{tx("study_intent." + intent + ".warning")}</p>
        <Check label={tx("i_am_sure")} checked={confirmed} onCheck={this.setConfirmed.bind(this)}/>
        <FormControls
          onSave={this.submit.bind(this)}
          onCancel={() => mc.ui.modal(null)}
          labels={{ "save": tx("study_intent." + intent), "cancel": tx("cancel") }}
          enabled={confirmed}/>
      </div>
    );
  }
}

module.exports = CompleteStudyView;
